import React, {Component} from "react"
import styles from "./H1.module.css"

interface Props {
    children: string
}

export class H3 extends Component<Props, {}> {
    public render() {
        const style = {fontSize: "18px"}
        return (
            <h3 className={styles.title} style={style}>
                {this.props.children}
            </h3>
        )
    }
}
